export default "__VITE_ASSET__96f5564e__"